// Offering Category Options
export const OFFERING_CATEGORY_OPTIONS = [
    { label: 'Consultation', value: 'CONSULTATION' },
    { label: 'Treatment', value: 'TREATMENT' },
    { label: 'LHR', value: 'LHR' },
    { label: 'Package', value: 'PACKAGE' },
    { label: 'Other', value: 'OTHER' },
] as const;

// Status Options
export const STATUS_OPTIONS = [
    { label: 'Active', value: true },
    { label: 'Inactive', value: false },
] as const;

// Category Filter Options
export const CATEGORY_FILTER_OPTIONS = OFFERING_CATEGORY_OPTIONS;

// Status Filter Options
export const STATUS_FILTER_OPTIONS = [
    { label: 'Active', value: '1' },
    { label: 'Inactive', value: '0' },
] as const; 